export const baseAPI = process.env.VUE_APP_BASE_URL;
